import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiLetModule } from '@taiga-ui/cdk';
import { TuiButtonModule, TuiDialogContext, TuiSvgModule } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';

@Component({
    selector: 'us-location-request',
    standalone: true,
    imports: [TranslocoModule, TuiSvgModule, TuiButtonModule, TuiLetModule, AsyncPipe],
    templateUrl: './location-request.component.html',
    styleUrls: ['./location-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationRequestComponent {
    private readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<{
        accepted: boolean;
    }>;

    close(accepted: boolean) {
        this.context.completeWith({ accepted });
    }
}
